export const abi = [
  {
    inputs: [],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'target',
        type: 'address',
      },
    ],
    name: 'AddressEmptyCode',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'implementation',
        type: 'address',
      },
    ],
    name: 'ERC1967InvalidImplementation',
    type: 'error',
  },
  {
    inputs: [],
    name: 'ERC1967NonPayable',
    type: 'error',
  },
  {
    inputs: [],
    name: 'FailedCall',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'balance',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'needed',
        type: 'uint256',
      },
    ],
    name: 'InsufficientBalance',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'fixedProjectFeePercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'flexibleSuccessfulProjectFeePercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'flexibleUnSuccessfulProjectFeePercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'investorFeePercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'gatewayFeePercentage',
        type: 'uint256',
      },
    ],
    name: 'InvalidFeesPercentage',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidInitialization',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'requested',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'min',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'max',
        type: 'uint256',
      },
    ],
    name: 'InvalidRequestedGoalAmount',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'sellerProcessingFeesPercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'sellerSuccessFeesPercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'buyerProcessingFeesPercentage',
        type: 'uint256',
      },
    ],
    name: 'InvalidSecondaryMarketFees',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'investor',
        type: 'address',
      },
      {
        internalType: 'bool',
        name: 'isAccreditedInvestor',
        type: 'bool',
      },
    ],
    name: 'NotAccreditedInvestor',
    type: 'error',
  },
  {
    inputs: [],
    name: 'NotInitializing',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
    ],
    name: 'OwnableInvalidOwner',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'OwnableUnauthorizedAccount',
    type: 'error',
  },
  {
    inputs: [],
    name: 'ReentrancyGuardReentrantCall',
    type: 'error',
  },
  {
    inputs: [],
    name: 'UUPSUnauthorizedCallContext',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'slot',
        type: 'bytes32',
      },
    ],
    name: 'UUPSUnsupportedProxiableUUID',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'string',
        name: 'referenceId',
        type: 'string',
      },
      {
        indexed: true,
        internalType: 'enum EquityCrowdfundingUpgradeable.SellStatus',
        name: 'status',
        type: 'uint8',
      },
    ],
    name: 'ChangeSellStatus',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'withDrawer',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'ClaimedEarnings',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'withDrawer',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'ClaimedRepayment',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'defender',
        type: 'address',
      },
    ],
    name: 'DefenderUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint64',
        name: 'version',
        type: 'uint64',
      },
    ],
    name: 'Initialized',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'creator',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'InvestmentClaimed',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'investor',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'investmentAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'purchasedShares',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'contractSignatureTimeStamp',
        type: 'uint256',
      },
    ],
    name: 'InvestmentMade',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'creator',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'string',
        name: 'projectName',
        type: 'string',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'requestedFunding',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'startDate',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'endDate',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'enum EquityCrowdfundingUpgradeable.RepaymentFrequency',
        name: 'repaymentFrequency',
        type: 'uint8',
      },
    ],
    name: 'InvestmentProjectCreated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'string',
        name: 'referenceId',
        type: 'string',
      },
      {
        indexed: true,
        internalType: 'uint216',
        name: 'numberofShareOnSell',
        type: 'uint216',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'pricePerShare',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'seller',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'enum EquityCrowdfundingUpgradeable.SellStatus',
        name: 'status',
        type: 'uint8',
      },
    ],
    name: 'OnSell',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: '_fixedProjectFeePercentage',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: '_fixedProjectFeeAmount',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: '_flexibleSuccessfulProjectFeePercentage',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_flexibleSuccessfulProjectFeeAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_flexibleUnSuccessfulProjectFeePercentage',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_flexibleUnsuccessfulProjectFeeAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_investorFeePercentage',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_investorFeeAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_gatewayFeePercentage',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_gatewayFeeAmount',
        type: 'uint256',
      },
    ],
    name: 'PlateformFeesUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'creator',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'string',
        name: 'name',
        type: 'string',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'requestedFunding',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'endDate',
        type: 'uint256',
      },
    ],
    name: 'ProjectCreated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'enum EquityCrowdfundingUpgradeable.ProjectStatus',
        name: 'status',
        type: 'uint8',
      },
    ],
    name: 'ProjectStatusUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'RefundInitiated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'nextRepaymentDate',
        type: 'uint256',
      },
    ],
    name: 'RepaymentProcessed',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'bool',
        name: 'isSellerSuccessFeesEnable',
        type: 'bool',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'sellerSuccessFeesPercentage',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'sellerProcessingFeesPercentage',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'buyerProcessingFeesPercentage',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'revertBackShareSellRequest',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'isAutoApproveShares',
        type: 'bool',
      },
    ],
    name: 'SecondarySettingUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'string',
        name: 'referenceId',
        type: 'string',
      },
      {
        indexed: true,
        internalType: 'uint216',
        name: 'shareReverted',
        type: 'uint216',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'enum EquityCrowdfundingUpgradeable.SellStatus',
        name: 'status',
        type: 'uint8',
      },
    ],
    name: 'ShareReverted',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'string',
        name: 'referenceId',
        type: 'string',
      },
      {
        indexed: true,
        internalType: 'uint216',
        name: 'shareQuantitySold',
        type: 'uint216',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'buyer',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'signatureTimestamp',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'enum EquityCrowdfundingUpgradeable.SellStatus',
        name: 'status',
        type: 'uint8',
      },
    ],
    name: 'ShareSold',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'minDays',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'maxDays',
        type: 'uint256',
      },
    ],
    name: 'UpdatedEndDaysRange',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'minIntrestRate',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'maxInterestRate',
        type: 'uint256',
      },
    ],
    name: 'UpdatedInterestRateRange',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'minInvestmentAmount',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'maxInvestmentAmount',
        type: 'uint256',
      },
    ],
    name: 'UpdatedInvestmentAmountLimit',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'minRequestAmount',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'maxRequestAmount',
        type: 'uint256',
      },
    ],
    name: 'UpdatedRequestAmountLimit',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'minTermLength',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'maxTermLength',
        type: 'uint256',
      },
    ],
    name: 'UpdatedTermLengthRange',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'implementation',
        type: 'address',
      },
    ],
    name: 'Upgraded',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'WithdrawRefund',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'string',
        name: 'referenceId',
        type: 'string',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'seller',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'WithdrawSellsEarnings',
    type: 'event',
  },
  {
    inputs: [],
    name: 'UPGRADE_INTERFACE_VERSION',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'referenceId',
        type: 'string',
      },
    ],
    name: 'approveSellRequest',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'referenceId',
        type: 'string',
      },
      {
        internalType: 'uint216',
        name: 'shareQuantity',
        type: 'uint216',
      },
      {
        internalType: 'uint256',
        name: 'signatureTimestamp',
        type: 'uint256',
      },
    ],
    name: 'buyShare',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'totalPurchaseAmount',
        type: 'uint256',
      },
    ],
    name: 'calculateBuyerProcessingFees',
    outputs: [
      {
        internalType: 'uint256',
        name: 'buyerProcessingFees',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'fundingReceived',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'investorCount',
        type: 'uint256',
      },
    ],
    name: 'calculateGatewayFee',
    outputs: [
      {
        internalType: 'uint256',
        name: 'gatewayFee',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'totalFunding',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'investmentAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'repaymentInstallmentAmount',
        type: 'uint256',
      },
    ],
    name: 'calculateInvestmentRepaymentShare',
    outputs: [
      {
        internalType: 'uint256',
        name: 'investorShare',
        type: 'uint256',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'investorShareAmount',
        type: 'uint256',
      },
    ],
    name: 'calculateInvestorFee',
    outputs: [
      {
        internalType: 'uint256',
        name: 'investorFee',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'fundingReceived',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: '_isFixedProject',
        type: 'bool',
      },
      {
        internalType: 'enum EquityCrowdfundingUpgradeable.ProjectStatus',
        name: 'projectStatus',
        type: 'uint8',
      },
      {
        internalType: 'uint256',
        name: 'investorCount',
        type: 'uint256',
      },
    ],
    name: 'calculatePlatformFees',
    outputs: [
      {
        internalType: 'uint256',
        name: 'platformfee',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'fundingReceived',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'interestRate',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'termLength',
        type: 'uint256',
      },
    ],
    name: 'calculateRepaymentInstallment',
    outputs: [
      {
        internalType: 'uint256',
        name: 'repaymentAmount',
        type: 'uint256',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'totalPurchaseAmount',
        type: 'uint256',
      },
    ],
    name: 'calculateSellerProcessingFees',
    outputs: [
      {
        internalType: 'uint256',
        name: 'sellerProcessingFees',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'totalPurchaseAmount',
        type: 'uint256',
      },
    ],
    name: 'calculateSellerSuccessFees',
    outputs: [
      {
        internalType: 'uint256',
        name: 'sellerSuccessFees',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'pricePerShare',
        type: 'uint256',
      },
    ],
    name: 'calculateShareSellingLimitAmount',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
    ],
    name: 'claimInvestment',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'creator',
        type: 'address',
      },
      {
        internalType: 'string',
        name: 'name',
        type: 'string',
      },
      {
        internalType: 'enum EquityCrowdfundingUpgradeable.InvestmentDealType',
        name: 'dealType',
        type: 'uint8',
      },
      {
        internalType: 'uint256',
        name: 'avaliableShare',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'endDate',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'minInvestmentValue',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'maxInvestmentValue',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'requestedFunding',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'interestRate',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'termLength',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'repaymentDate',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'isFixedProject',
        type: 'bool',
      },
      {
        internalType: 'bool',
        name: 'isForAccreditedInvestor',
        type: 'bool',
      },
      {
        internalType: 'enum EquityCrowdfundingUpgradeable.RepaymentFrequency',
        name: 'repaymentFrequency',
        type: 'uint8',
      },
    ],
    name: 'createProject',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'ownerAdddress',
        type: 'address',
      },
    ],
    name: 'earnings',
    outputs: [
      {
        internalType: 'uint256',
        name: 'withdrawalAmount',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getDefenderAddress',
    outputs: [
      {
        internalType: 'address',
        name: 'defender',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getEndDaysRange',
    outputs: [
      {
        internalType: 'uint256',
        name: 'minDays',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'maxDays',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getGoalAmountLimit',
    outputs: [
      {
        internalType: 'uint256',
        name: 'minGoalAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'maxGoalAmount',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getInterestRate',
    outputs: [
      {
        internalType: 'uint256',
        name: 'minInterestRate',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'maxInterestRate',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getInvestmentValueLimit',
    outputs: [
      {
        internalType: 'uint256',
        name: 'minInvestmentValue',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'maxInvestmentValue',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
    ],
    name: 'getInvestorCount',
    outputs: [
      {
        internalType: 'uint256',
        name: 'investorCount',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_currentDate',
        type: 'uint256',
      },
      {
        internalType: 'enum EquityCrowdfundingUpgradeable.RepaymentFrequency',
        name: '_frequency',
        type: 'uint8',
      },
    ],
    name: 'getNextPaymentDate',
    outputs: [
      {
        internalType: 'uint256',
        name: 'date',
        type: 'uint256',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getPlatformFees',
    outputs: [
      {
        internalType: 'uint256',
        name: 'fixedProjectFeeAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'fixedProjectFeePercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'flexibleSuccessfulProjectFeeAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'flexibleSuccessfulProjectFeePercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'flexibleUnsuccessfulProjectFeeAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'flexibleUnsuccessfulProjectFeePercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'investorFeeAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'investorFeePercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'gatewayFeeAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'gatewayFeePercentage',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getSecondaryMarketFees',
    outputs: [
      {
        internalType: 'bool',
        name: 'isSellerSuccessFeesEnable',
        type: 'bool',
      },
      {
        internalType: 'bool',
        name: 'isAutoApproveEnable',
        type: 'bool',
      },
      {
        internalType: 'uint256',
        name: 'sellerSuccessFeesPercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'sellerProcessingFeesPercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'sellerProcessingFeesFixed',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'buyerProcessingFeesPercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'buyerProcessingFeesFixed',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'shareSellingLimit',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'isShareSellingLimitEnable',
        type: 'bool',
      },
      {
        internalType: 'uint256',
        name: 'revertBackShareSellRequest',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getTermLengthRange',
    outputs: [
      {
        internalType: 'uint256',
        name: 'minTermLength',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'maxTermLength',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'creatorAddress',
        type: 'address',
      },
    ],
    name: 'hasClaimInvestment',
    outputs: [
      {
        internalType: 'bool',
        name: 'isInvestmentClaimed',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'fixedProjectFeePercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'fixedProjectFeeAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'flexibleSuccessfulProjectFeePercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'flexibleSuccessfulProjectFeeAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'flexibleUnSuccessfulProjectFeePercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'flexibleUnsuccessfulProjectFeeAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'investorFeePercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'investorFeeAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'gatewayFeePercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'gatewayFeeAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'sellerSuccessFeesPercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'sellerProcessingFeesPercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'sellerProcessingFeesFixed',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'buyerProcessingFeesPercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'buyerProcessingFeesFixed',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'shareSellingLimit',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'defender',
        type: 'address',
      },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'purchaseShare',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'isAccreditedInvestor',
        type: 'bool',
      },
      {
        internalType: 'uint256',
        name: 'contractSignatureTimeStamp',
        type: 'uint256',
      },
    ],
    name: 'investInProject',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'investorAddress',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
    ],
    name: 'investorRefundAmount',
    outputs: [
      {
        internalType: 'uint256',
        name: 'refundAmount',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'referenceId',
        type: 'string',
      },
    ],
    name: 'onSellDetails',
    outputs: [
      {
        internalType: 'uint216',
        name: 'numberOfSharesOnSell',
        type: 'uint216',
      },
      {
        internalType: 'uint216',
        name: 'numberOfSharesSold',
        type: 'uint216',
      },
      {
        internalType: 'uint256',
        name: 'pricePerShare',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'sellTimeStamp',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'seller',
        type: 'address',
      },
      {
        internalType: 'enum EquityCrowdfundingUpgradeable.SellStatus',
        name: 'status',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
    ],
    name: 'processRepaymentInstallment',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'investorAddress',
        type: 'address',
      },
    ],
    name: 'projectInvestors',
    outputs: [
      {
        internalType: 'uint256',
        name: 'amountInvested',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'claimedInvestment',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'isAccreditedInvestor',
        type: 'bool',
      },
      {
        internalType: 'uint256',
        name: 'purchasedShare',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'projectInvestorsList',
    outputs: [
      {
        internalType: 'address',
        name: 'projectInvestors',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
    ],
    name: 'projects',
    outputs: [
      {
        internalType: 'address',
        name: 'creator',
        type: 'address',
      },
      {
        internalType: 'string',
        name: 'name',
        type: 'string',
      },
      {
        internalType: 'uint256',
        name: 'endDate',
        type: 'uint256',
      },
      {
        internalType: 'enum EquityCrowdfundingUpgradeable.InvestmentDealType',
        name: 'dealType',
        type: 'uint8',
      },
      {
        internalType: 'uint256',
        name: 'avaliableShare',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'pricePerShare',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'minInvestmentValue',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'maxInvestmentValue',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'requestedFunding',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'fundingReceived',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'remainingRepaymentAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'repaymentInstallmentAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'interestRate',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'termLength',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'repaymentDate',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'isFixedProject',
        type: 'bool',
      },
      {
        internalType: 'bool',
        name: 'isForAccreditedInvestor',
        type: 'bool',
      },
      {
        internalType: 'enum EquityCrowdfundingUpgradeable.ProjectStatus',
        name: 'projectStatus',
        type: 'uint8',
      },
      {
        internalType: 'enum EquityCrowdfundingUpgradeable.RepaymentFrequency',
        name: 'repaymentFrequency',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'proxiableUUID',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'referenceId',
        type: 'string',
      },
      {
        internalType: 'uint216',
        name: 'numberOfShareOnSell',
        type: 'uint216',
      },
      {
        internalType: 'uint256',
        name: 'pricePerShare',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
    ],
    name: 'putShareOnSell',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'investor',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'refundAmount',
        type: 'uint256',
      },
    ],
    name: 'refundInvestment',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'referenceId',
        type: 'string',
      },
    ],
    name: 'rejectSellRequest',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'investorAddress',
        type: 'address',
      },
    ],
    name: 'remainingInstallmentsToClaim',
    outputs: [
      {
        internalType: 'uint256',
        name: 'remainingInstallmentAmount',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'referenceId',
        type: 'string',
      },
    ],
    name: 'revertRemainingShare',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'seller',
        type: 'address',
      },
      {
        internalType: 'string',
        name: 'referenceId',
        type: 'string',
      },
    ],
    name: 'sellerEarnings',
    outputs: [
      {
        internalType: 'uint256',
        name: 'earnings',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'minDays',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'maxDays',
        type: 'uint256',
      },
    ],
    name: 'setEndDaysRange',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'minAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'maxAmount',
        type: 'uint256',
      },
    ],
    name: 'setGoalAmountLimit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'minIR',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'maxIR',
        type: 'uint256',
      },
    ],
    name: 'setInterestRateRange',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'minInvestmentAmt',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'maxInvestmentAmt',
        type: 'uint256',
      },
    ],
    name: 'setInvestmentAmtLimit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'fixedProjectFeePercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'fixedProjectFeeAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'flexibleSuccessfulProjectFeePercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'flexibleSuccessfulProjectFeeAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'flexibleUnSuccessfulProjectFeePercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'flexibleUnsuccessfulProjectFeeAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'investorFeePercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'investorFeeAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'gatewayFeePercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'gatewayFeeAmount',
        type: 'uint256',
      },
    ],
    name: 'setPlatformFees',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
    ],
    name: 'setProjectStatusActive',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
    ],
    name: 'setProjectStatusInactive',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
    ],
    name: 'setProjectStatusPending',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
    ],
    name: 'setProjectStatusUnsuccessful',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bool',
        name: 'isSellerSuccessFeesEnable',
        type: 'bool',
      },
      {
        internalType: 'uint256',
        name: 'sellerSuccessFeesPercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'sellerProcessingFeesPercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'sellerProcessingFeesFixed',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'buyerProcessingFeesPercentage',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'buyerProcessingFeesFixed',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'revertBackShareSellRequest',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'shareSellingLimit',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'isShareSellingLimitEnable',
        type: 'bool',
      },
      {
        internalType: 'bool',
        name: 'isAutoApproveShares',
        type: 'bool',
      },
    ],
    name: 'setSecondaryMarketFees',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'minTermLength',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'maxTermLength',
        type: 'uint256',
      },
    ],
    name: 'setTermLengthRange',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'defender',
        type: 'address',
      },
    ],
    name: 'updateDefender',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newImplementation',
        type: 'address',
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes',
      },
    ],
    name: 'upgradeToAndCall',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'version',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [],
    name: 'withdrawEarning',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
    ],
    name: 'withdrawRefund',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'projectId',
        type: 'uint256',
      },
    ],
    name: 'withdrawRepayment',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'referenceId',
        type: 'string',
      },
    ],
    name: 'withdrawSoldShareEarnings',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    stateMutability: 'payable',
    type: 'receive',
  },
];

export const tokenizationAbi = [
  {
    type: 'constructor',
    payable: false,
    inputs: [],
  },
  {
    type: 'error',
    name: 'AddressEmptyCode',
    inputs: [
      {
        type: 'address',
        name: 'target',
      },
    ],
  },
  {
    type: 'error',
    name: 'ERC1967InvalidImplementation',
    inputs: [
      {
        type: 'address',
        name: 'implementation',
      },
    ],
  },
  {
    type: 'error',
    name: 'ERC1967NonPayable',
    inputs: [],
  },
  {
    type: 'error',
    name: 'EmptyString',
    inputs: [
      {
        type: 'string',
        name: 'name',
      },
      {
        type: 'string',
        name: 'fieldName',
      },
    ],
  },
  {
    type: 'error',
    name: 'FailedCall',
    inputs: [],
  },
  {
    type: 'error',
    name: 'InsufficientAmountBalance',
    inputs: [
      {
        type: 'address',
        name: 'user',
      },
      {
        type: 'uint256',
        name: 'balance',
      },
    ],
  },
  {
    type: 'error',
    name: 'InsufficientBalance',
    inputs: [
      {
        type: 'uint256',
        name: 'balance',
      },
      {
        type: 'uint256',
        name: 'needed',
      },
    ],
  },
  {
    type: 'error',
    name: 'InvalidInitialization',
    inputs: [],
  },
  {
    type: 'error',
    name: 'NotInitializing',
    inputs: [],
  },
  {
    type: 'error',
    name: 'OwnableInvalidOwner',
    inputs: [
      {
        type: 'address',
        name: 'owner',
      },
    ],
  },
  {
    type: 'error',
    name: 'OwnableUnauthorizedAccount',
    inputs: [
      {
        type: 'address',
        name: 'account',
      },
    ],
  },
  {
    type: 'error',
    name: 'ProjectNotExist',
    inputs: [
      {
        type: 'uint32',
        name: 'projectId',
      },
    ],
  },
  {
    type: 'error',
    name: 'ReentrancyGuardReentrantCall',
    inputs: [],
  },
  {
    type: 'error',
    name: 'SafeERC20FailedOperation',
    inputs: [
      {
        type: 'address',
        name: 'token',
      },
    ],
  },
  {
    type: 'error',
    name: 'UUPSUnauthorizedCallContext',
    inputs: [],
  },
  {
    type: 'error',
    name: 'UUPSUnsupportedProxiableUUID',
    inputs: [
      {
        type: 'bytes32',
        name: 'slot',
      },
    ],
  },
  {
    type: 'error',
    name: 'ZeroAddress',
    inputs: [
      {
        type: 'address',
        name: 'zeroAddress',
      },
      {
        type: 'string',
        name: 'fieldName',
      },
    ],
  },
  {
    type: 'event',
    anonymous: false,
    name: 'CampaignStatusUpdated',
    inputs: [
      {
        type: 'uint32',
        name: 'projectId',
        indexed: true,
      },
      {
        type: 'uint8',
        name: 'status',
        indexed: true,
      },
    ],
  },
  {
    type: 'event',
    anonymous: false,
    name: 'EarningWithdraw',
    inputs: [
      {
        type: 'address',
        name: 'user',
        indexed: true,
      },
      {
        type: 'uint256',
        name: 'amount',
        indexed: true,
      },
    ],
  },
  {
    type: 'event',
    anonymous: false,
    name: 'Initialized',
    inputs: [
      {
        type: 'uint64',
        name: 'version',
        indexed: false,
      },
    ],
  },
  {
    type: 'event',
    anonymous: false,
    name: 'Invested',
    inputs: [
      {
        type: 'uint32',
        name: 'projectId',
        indexed: true,
      },
      {
        type: 'address',
        name: 'investor',
        indexed: true,
      },
      {
        type: 'uint256',
        name: 'amount',
        indexed: true,
      },
      {
        type: 'uint256',
        name: 'contractSignatureTimeStamp',
        indexed: false,
      },
    ],
  },
  {
    type: 'event',
    anonymous: false,
    name: 'InvestmentWithdraw',
    inputs: [
      {
        type: 'uint32',
        name: 'projectId',
        indexed: true,
      },
      {
        type: 'uint256',
        name: 'amount',
        indexed: true,
      },
      {
        type: 'address',
        name: 'creator',
        indexed: true,
      },
    ],
  },
  {
    type: 'event',
    anonymous: false,
    name: 'OwnershipTransferred',
    inputs: [
      {
        type: 'address',
        name: 'previousOwner',
        indexed: true,
      },
      {
        type: 'address',
        name: 'newOwner',
        indexed: true,
      },
    ],
  },
  {
    type: 'event',
    anonymous: false,
    name: 'ProjectCreated',
    inputs: [
      {
        type: 'address',
        name: 'tokenAddress',
        indexed: true,
      },
      {
        type: 'address',
        name: 'creator',
        indexed: true,
      },
      {
        type: 'uint32',
        name: 'projectId',
        indexed: true,
      },
      {
        type: 'string',
        name: 'projectSlug',
        indexed: false,
      },
    ],
  },
  {
    type: 'event',
    anonymous: false,
    name: 'Upgraded',
    inputs: [
      {
        type: 'address',
        name: 'implementation',
        indexed: true,
      },
    ],
  },
  {
    type: 'function',
    name: 'UPGRADE_INTERFACE_VERSION',
    constant: true,
    stateMutability: 'view',
    payable: false,
    inputs: [],
    outputs: [
      {
        type: 'string',
      },
    ],
  },
  {
    type: 'function',
    name: 'calculateGatewayFees',
    constant: true,
    stateMutability: 'view',
    payable: false,
    inputs: [
      {
        type: 'uint256',
        name: '_fundingRaised',
      },
      {
        type: 'uint32',
        name: '_noOfInvestors',
      },
    ],
    outputs: [
      {
        type: 'uint256',
      },
    ],
  },
  {
    type: 'function',
    name: 'calculatePlatformFees',
    constant: true,
    stateMutability: 'view',
    payable: false,
    inputs: [
      {
        type: 'uint256',
        name: '_fundingRaised',
      },
      {
        type: 'uint32',
        name: '_noOfInvestors',
      },
    ],
    outputs: [
      {
        type: 'uint256',
      },
    ],
  },
  {
    type: 'function',
    name: 'calculatePrice',
    constant: true,
    stateMutability: 'pure',
    payable: false,
    inputs: [
      {
        type: 'uint256',
        name: 'goal',
      },
      {
        type: 'uint256',
        name: 'totalSupply',
      },
    ],
    outputs: [
      {
        type: 'uint256',
      },
    ],
  },
  {
    type: 'function',
    name: 'campaignDetails',
    constant: true,
    stateMutability: 'view',
    payable: false,
    inputs: [
      {
        type: 'uint32',
        name: 'projectId',
      },
    ],
    outputs: [
      {
        type: 'address',
        name: 'creator',
      },
      {
        type: 'string',
        name: 'projectSlug',
      },
      {
        type: 'address',
        name: 'tokenAddress',
      },
      {
        type: 'uint256',
        name: 'endDate',
      },
      {
        type: 'uint256',
        name: 'goal',
      },
      {
        type: 'uint256',
        name: 'minInvestment',
      },
      {
        type: 'uint256',
        name: 'maxInvestment',
      },
      {
        type: 'uint256',
        name: 'raisedInvestments',
      },
      {
        type: 'uint256',
        name: 'pricePerFullTokenUnit',
      },
      {
        type: 'uint256',
        name: 'totalSupply',
      },
      {
        type: 'uint32',
        name: 'noOfInvestors',
      },
      {
        type: 'uint8',
        name: 'campaignStatus',
      },
    ],
  },
  {
    type: 'function',
    name: 'createProject',
    constant: false,
    payable: false,
    inputs: [
      {
        type: 'address',
        name: 'creator',
      },
      {
        type: 'string',
        name: 'projectSlug',
      },
      {
        type: 'string',
        name: 'tokenName',
      },
      {
        type: 'string',
        name: 'tokenSymbol',
      },
      {
        type: 'uint256',
        name: 'endDate',
      },
      {
        type: 'uint256',
        name: 'totalSupply',
      },
      {
        type: 'uint256',
        name: 'goal',
      },
      {
        type: 'uint256',
        name: 'minInvestment',
      },
      {
        type: 'uint256',
        name: 'maxInvestment',
      },
    ],
    outputs: [],
  },
  {
    type: 'function',
    name: 'getDefenderAddress',
    constant: true,
    stateMutability: 'view',
    payable: false,
    inputs: [],
    outputs: [
      {
        type: 'address',
      },
    ],
  },
  {
    type: 'function',
    name: 'getFactoryAddress',
    constant: true,
    stateMutability: 'view',
    payable: false,
    inputs: [],
    outputs: [
      {
        type: 'address',
      },
    ],
  },
  {
    type: 'function',
    name: 'getPlatformDetails',
    constant: true,
    stateMutability: 'view',
    payable: false,
    inputs: [],
    outputs: [
      {
        type: 'uint16',
      },
      {
        type: 'uint16',
      },
      {
        type: 'uint256',
      },
      {
        type: 'uint256',
      },
    ],
  },
  {
    type: 'function',
    name: 'getTokensQuantity',
    constant: true,
    stateMutability: 'pure',
    payable: false,
    inputs: [
      {
        type: 'uint256',
        name: '_tokenPrices',
      },
      {
        type: 'uint256',
        name: '_investingAmount',
      },
    ],
    outputs: [
      {
        type: 'uint256',
      },
    ],
  },
  {
    type: 'function',
    name: 'initialize',
    constant: false,
    payable: false,
    inputs: [
      {
        type: 'uint16',
        name: '_percentage',
      },
      {
        type: 'uint256',
        name: '_amount',
      },
      {
        type: 'uint16',
        name: '_gatewayPercentage',
      },
      {
        type: 'uint256',
        name: '_gatewayAmount',
      },
      {
        type: 'address',
        name: '_defenderAddress',
      },
    ],
    outputs: [],
  },
  {
    type: 'function',
    name: 'invest',
    constant: false,
    stateMutability: 'payable',
    payable: true,
    inputs: [
      {
        type: 'uint32',
        name: '_projectId',
      },
      {
        type: 'uint256',
        name: 'contractSignatureTimeStamp',
      },
    ],
    outputs: [],
  },
  {
    type: 'function',
    name: 'investorDetails',
    constant: true,
    stateMutability: 'view',
    payable: false,
    inputs: [
      {
        type: 'uint32',
        name: 'projectId',
      },
      {
        type: 'address',
        name: 'investorAddress',
      },
    ],
    outputs: [
      {
        type: 'uint256',
        name: 'investedAmount',
      },
      {
        type: 'bool',
        name: 'isRefunded',
      },
    ],
  },
  {
    type: 'function',
    name: 'owner',
    constant: true,
    stateMutability: 'view',
    payable: false,
    inputs: [],
    outputs: [
      {
        type: 'address',
      },
    ],
  },
  {
    type: 'function',
    name: 'platformEarnings',
    constant: true,
    stateMutability: 'view',
    payable: false,
    inputs: [
      {
        type: 'address',
        name: 'owner',
      },
    ],
    outputs: [
      {
        type: 'uint256',
        name: 'earnings',
      },
    ],
  },
  {
    type: 'function',
    name: 'proxiableUUID',
    constant: true,
    stateMutability: 'view',
    payable: false,
    inputs: [],
    outputs: [
      {
        type: 'bytes32',
      },
    ],
  },
  {
    type: 'function',
    name: 'renounceOwnership',
    constant: false,
    payable: false,
    inputs: [],
    outputs: [],
  },
  {
    type: 'function',
    name: 'transferOwnership',
    constant: false,
    payable: false,
    inputs: [
      {
        type: 'address',
        name: 'newOwner',
      },
    ],
    outputs: [],
  },
  {
    type: 'function',
    name: 'updateCampaignToUnsuccessful',
    constant: false,
    payable: false,
    inputs: [
      {
        type: 'uint32',
        name: '_projectId',
      },
    ],
    outputs: [],
  },
  {
    type: 'function',
    name: 'updateDefender',
    constant: false,
    payable: false,
    inputs: [
      {
        type: 'address',
        name: '_defenderAddress',
      },
    ],
    outputs: [],
  },
  {
    type: 'function',
    name: 'updatePlateformFees',
    constant: false,
    payable: false,
    inputs: [
      {
        type: 'uint16',
        name: '_percentage',
      },
      {
        type: 'uint256',
        name: '_amount',
      },
      {
        type: 'uint16',
        name: '_gatewayPercentage',
      },
      {
        type: 'uint256',
        name: '_gatewayAmount',
      },
    ],
    outputs: [],
  },
  {
    type: 'function',
    name: 'upgradeToAndCall',
    constant: false,
    stateMutability: 'payable',
    payable: true,
    inputs: [
      {
        type: 'address',
        name: 'newImplementation',
      },
      {
        type: 'bytes',
        name: 'data',
      },
    ],
    outputs: [],
  },
  {
    type: 'function',
    name: 'withdrawEarnings',
    constant: false,
    payable: false,
    inputs: [],
    outputs: [],
  },
  {
    type: 'function',
    name: 'withdrawInvesment',
    constant: false,
    payable: false,
    inputs: [
      {
        type: 'uint32',
        name: '_projectId',
      },
    ],
    outputs: [],
  },
];
